var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81818 0H5.45455L0 22H4.36364L9.81818 0Z",
    fill: "#01021E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H13.6364L8.18181 22H12.5455L18 0Z",
    fill: "#01021E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation);
export default __webpack_public_path__ + "static/media/quotation.d1fd600227bb8d0c27c5e52d166106ed.svg";
export { ForwardRef as ReactComponent };